const DiaryDetails = {
  'id': 'DiaryDetails',
  'layout': {
    'rows': 1,
    'columns': 1
  },
  'fields': [
    {
      'id': '1',
      'type': 'PAPER_CONTAINER',
      'props': {
        'name': 'notepad',
        'fullWidth': true
      },
      'position': {
        'row': 1,
        'col': 1,
        'colspan': 2
      },
      'children': [
        {
          id: 1,
          type: 'DIARY_DETAILS',
          props: {
            label: 'CustomerQuoteDiary',
            name: 'DiaryDetails',
            createApi: '/CustomerQuoteEnquiry/Quote/<DocumentNumber>/CreateDiary',
            searchByIdApi: '/CustomerQuoteEnquiry/Quote/<DocumentNumber>/Diary/<DiaryId>',
            updateApi: '/CustomerQuoteEnquiry/Quote/<DocumentNumber>/Diary/<DiaryId>',
            deleteApi: '/CustomerQuoteEnquiry/Quote/<DocumentNumber>/Diary/<DiaryId>'
          }
        }
      ]
    }
  ]
}
export default DiaryDetails
